/**
 * 양식 업무 종류 (docType)
 * SSOT: D:\295\erp\CM\design\05_양식레지스트리_매칭.md
 */

export const DOC_TYPE = {
  BIZ_PLAN: 'BIZ_PLAN',
  EXP_RESOLUTION: 'EXP_RESOLUTION',
  EXP_PROPOSAL: 'EXP_PROPOSAL',
};

export const DOC_TYPE_LABEL = {
  [DOC_TYPE.BIZ_PLAN]: '사업계획서',
  [DOC_TYPE.EXP_RESOLUTION]: '지출결의서',
  [DOC_TYPE.EXP_PROPOSAL]: '지출품의서',
};

export const DOC_TYPE_OPTIONS = Object.keys(DOC_TYPE).map((k) => ({
  value: DOC_TYPE[k],
  label: DOC_TYPE_LABEL[DOC_TYPE[k]],
}));
